module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap",
    attrs: {
      "id": "toc"
    }
  }, [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("___________________")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/script"
    }
  }, [_vm._v("Great Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1. Every Boy Should Have a Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("2. His Female Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Proper Kennel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. His Musical Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Red Man, Red Man, Why Do You Weep?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Man at War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. In Fever in War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Their World Shall Pass Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Mans of the Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Red Locks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Oaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Mike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sing oh Sing of Great Lord Uulf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great Lord Uulf Is Brought Down Low")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death Song of Great Lord Uulf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Song of Great Lord Gerwargerulf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harp Song 104")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Do My Goodness Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Little Man Mans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/apoc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mikel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bonus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus: Excerpt from "), _c('i', [_vm._v("Jesus Boy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/allnothing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Preston L. Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Preston L. Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/akb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Akashic Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 66
// module chunks = 0